export default "__VITE_ASSET__yjdd552S__"